import { Controller, FormContainer, useFormContext } from 'react-hook-form-mui';
import * as CS from 'view/pages/profile/commonStyled';
import { Button } from 'view/components';
import { useGetDropdownData } from 'view/pages/profile/hooks/useGetDropdownData';
import { DropdownsEnum } from 'infrastructure/enums/DropdownsEnum';
import Select from './Select';
import MultiplySelect from './MultiplySelect';

const genderOptions = [
  { id: 1, name: 'Male' },
  { id: 2, name: 'Female' },
  { id: 3, name: 'Non-Binary' },
  { id: 4, name: 'Prefer not to say' },
  { id: 5, name: 'Other' },
];

interface IFormInput {
  gender: any;
  positionType: any;
}

const TestFormFields = () => {
  const {
    /* watch, */
    control,
    /* setValue,
    register, */
    formState: { errors },
  } = useFormContext<IFormInput>();

  /* const positionTypeValues = watch('positionType') ?? []; */

  const { data: positionTypeData, isLoading: isPositionTypeDataLoading } = useGetDropdownData(
    DropdownsEnum.POSITION_TYPE
  );

  return (
    <>
      <Controller
        name="gender"
        control={control}
        rules={{ required: 'This field is required' }}
        render={({ field }) => {
          return (
            <Select
              {...field}
              label="Job Title / Role (Desired)"
              options={genderOptions}
              selectedValue={field.value}
              onChange={(selected) => {
                return field.onChange(selected);
              }}
              error={errors?.gender?.message}
              disabled={false}
            />
          );
        }}
      />
      <MultiplySelect
        name="positionType"
        label="Position Type"
        options={positionTypeData || []}
        control={control} // Используем контроль из RHF
        rules={{ required: 'This field is required' }} // Валидация
        error={errors?.positionType?.message} // Ошибка валидации
        disabled={isPositionTypeDataLoading || !positionTypeData}
      />
      <Button variant="contained" type="submit" text="Save" style={{ margin: '32px 0' }} />
    </>
  );
};

const TestPage = () => {
  const defaultValues = {
    gender: null, // Начальное значение
    positionType: [], // Начальное значение
  };

  const onSubmit = (formData: any) => {
    console.log(formData); // gender - объект, а не строка
  };

  return (
    <CS.ProfileMainWrapper>
      <CS.FormWrapper>
        <FormContainer defaultValues={defaultValues} onSuccess={onSubmit}>
          <TestFormFields />
        </FormContainer>
      </CS.FormWrapper>
    </CS.ProfileMainWrapper>
  );
};

export default TestPage;
